<template>
  <v-layout xs12 md12 px-0 class="client-details-container">
    <v-flex class="client-details-column">
      <client-details-component
        :profile="clientData"
      />
      <client-need-want
        :preference-type="'Need'"
      />
    </v-flex>
    <v-flex class="client-details-column">
      <client-documents
        :profile="clientData"
      />
      <client-need-want
        :preference-type="'Want'"
      />
    </v-flex>
    <v-flex class="client-details-column">
      <client-saved-search
        :saved-search="clientData.autosearch ? clientData.autosearch[0] : null"
      />
      <client-notes
        :profile="clientData"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import ClientNeedWant from './Components/ClientNeedWant'
import ClientDetailsComponent from './Components/ClientDetailsComponent'
import ClientDocuments from './Components/ClientDocuments'
import ClientNotes from './Components/ClientNotes'
import ClientSavedSearch from './Components/ClientSavedSearch'
import { mapState } from 'vuex'
import colors from '../../scss/_colors.scss'
export default {
  components: {
    ClientNeedWant,
    ClientDetailsComponent,
    ClientDocuments,
    ClientSavedSearch,
    ClientNotes
  },
  data() {
    return {
      colors
    }
  },
  computed: {
    ...mapState('client', ['clientData'])
  }

}
</script>
<style lang="sass">
.client-details-container
  display: flex
  flex-direction: row !important
  flex-wrap: wrap !important
  justify-content: center
  @media only screen and (max-width: 760px)
    flex-direction: column !important
.client-details-column
  display: flex
  flex-direction: column
  justify-content: center
  width: 32% !important
  // width: 48%
  @media only screen and (max-width: 1024px)
    margin-top: 2rem
  @media only screen and (max-width: 760px)
    width: 100% !important

.client-details-column:not(:first-child)
  margin-left: 2rem
  @media only screen and (max-width: 760px)
    margin-left: 0
.client-details-column:last-child
   @media only screen and (max-width: 1024px)
      margin-left: 0
      width: 100% !important
.client-details-column .client-need-want, .client-details-column
  margin-top: 2rem
.client-details-column .client-saved-search
  margin-bottom: 2rem
</style>
